import API from '@/org-app/api';
import { createApiAction, createGetAllAction, createGetOneAction, createPostAction } from '@/utils/ActionsUtils';

import * as types from './mutation-types';

export default {
  getAudienceRuleCustomGroups: createGetAllAction(
    API.instance.getAudienceCustomGroups,
    types.UPDATE_AUDIENCERULE_CUSTOM_GROUPS_LIST,
    'messages.failedToGetAudienceRule',
    false,
  ),
  getAudienceRuleCustomGroup: createGetOneAction(
    API.instance.getAudienceCustomGroup,
    types.SAVE_AUDIENCERULE_CUSTOM_GROUP,
    'messages.failedToGetAudienceRule',
  ),
  createAudienceRuleCustomGroup: createPostAction(
    API.instance.postAudienceCustomGroup,
    types.SAVE_AUDIENCERULE_CUSTOM_GROUP,
    'messages.failedToSaveAudienceRule',
  ),
  updateAudienceRuleCustomGroup: createApiAction(
    API.instance.putAudienceCustomGroup,
    null,
    'messages.failedToUpdateAudienceRule',
  ),
};
